<template>
  <div v-for="alert in alerts" :key="alert.id" class="alert">
    <div class="alert__content">
      <div class="alert__title">
        <span>{{ alert.title }}</span>
      </div>
      <div class="alert__text">
        <span>{{ alert.text }}</span>
      </div>
    </div>
    <div class="alert__close-button">
      <button class="btn-close" :aria-label="$t('ARIA.CLOSE_MODAL')" @click="closeAlert">
        <CloseIcon class="icon" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import useAlert from '@/services/useAlert';

const { alerts, closeAlert } = useAlert();
</script>
